<template>
  <form class="form-dom" action="https://perfectmoney.is/api/step1.asp" method="POST" target="_blank">
      <input type="hidden" name="PAYEE_NAME" :value="perfectmoneyInfo.PAYEE_NAME">
      <input type="hidden" name="PAYMENT_ID" :value="perfectmoneyInfo.PAYMENT_ID">
      <input type="hidden" name="PAYEE_ACCOUNT" :value="perfectmoneyInfo.PAYEE_ACCOUNT">
      <input type="hidden" name="PAYMENT_AMOUNT" :value="perfectmoneyInfo.PAYMENT_AMOUNT">
      <input type="hidden" name="PAYMENT_UNITS" :value="perfectmoneyInfo.PAYMENT_UNITS">
      <input type="hidden" name="STATUS_URL" :value="perfectmoneyInfo.STATUS_URL">
      <input type="hidden" name="PAYMENT_URL" :value="perfectmoneyInfo.PAYMENT_URL">
      <input type="hidden" name="NOPAYMENT_URL" :value="perfectmoneyInfo.NOPAYMENT_URL">
      <input type="hidden" name="PAYMENT_URL_METHOD" :value="perfectmoneyInfo.PAYMENT_URL_METHOD">
      <input type="hidden" name="NOPAYMENT_URL_METHOD" :value="perfectmoneyInfo.NOPAYMENT_URL_METHOD">
      <input type="hidden" name="INTERFACE_LANGUAGE" :value="language">
      <div class="mockbtn pointer">
        {{$t('root.confirm')}}
        <input
          @click="submit"
          type="submit"
          class="perfectmoney-submitbtn"
          id="perfectmoneybtn"
          name="PAYMENT_METHOD"
          :value="$t('root.confirm')"
        >
      </div>
  </form>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: "perfectMoneyForm",
  props: {
    perfectmoneyInfo: {
      type: Object,
      default(){
        return {
          perfectmoneyInfo: {
            PAYEE_NAME: '',
            PAYMENT_ID: '',
            PAYEE_ACCOUNT: '',
            PAYMENT_AMOUNT: '',
            PAYMENT_UNITS: '',

            STATUS_URL: '',
            PAYMENT_URL: '',
            NOPAYMENT_URL: '',
            PAYMENT_URL_METHOD: '',

            billAmount: '',
            amount: '',
            currency: '',
          },
        }
      }
    },
  },
  computed: {
    ...mapGetters(['language']),
  },
  methods: {
    submit(){
      this.$emit('formsubmit');
    }
  },
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variable';
.form-dom {
  display: inline-block;
}
.mockbtn {
  display: inline-block;
  width: 70px;
  height: 40px;
  margin: 0 auto;
  border-radius: 4px;
  line-height: 40px;
  text-align: center;
  color: #FFFFFF;
  background-color: $themeColor;
  position: relative;
  .perfectmoney-submitbtn {
    display: block;
    width: 100%;
    height: 100%;
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 99;
    cursor: pointer;
  }
}
</style>
